module.exports = __webpack_public_path__ + "static/img/注意防尘.3d3f85e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/注意防尘.png
// module id = ALg5
// module chunks = 1